export default "__VITE_ASSET__CWZ4xUdl__"